export default "__VITE_ASSET__31467ae2__"